<template>
    <Modal
            v-model="_value"
            width="500"
            title="通立硬盘报警"
            @on-visible-change="visibleChange"
            ok-text="关闭"
            cancel-text="">
        <Form ref="setHardDiskSlarmModal" v-model="setHardDiskSlarmModal" :label-width="80">

          <CheckboxGroup v-model="border">
            <Checkbox label="硬盘" border></Checkbox>
            <Checkbox label="SD1" border></Checkbox>
            <Checkbox label="SD2" border></Checkbox>
          </CheckboxGroup>

            <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
    </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'tlsetharddiskslarmmodal',
  components: {},
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setHardDiskSlarmModal: {
        id: null,
        en: 1,
        hdd: 1,
        sd1: null,
        sd2: null,
      },
      border:["硬盘"],
      JSON:"$STORE,1,",
      JSONlist:[],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setHardDiskSlarmModal.id = this._initValue
        this.setHardDiskSlarmModal.en = 1
        this.setHardDiskSlarmModal.hdd = 1
        this.setHardDiskSlarmModal.sd1 = null
        this.setHardDiskSlarmModal.sd2 = null
      }
    },

    onSendDriverCardParams () {
      console.log(this.border)
      for (let i = 0; i < this.border.length; i++) {
        // console.log(this.JSON)
        // console.log(this.border[i])
        switch (this.border[i]) {
          case "硬盘":
            this.JSONlist.push(1)
            break
          case "SD1":
            this.JSONlist.push(2)
            break
          case "SD2":
            this.JSONlist.push(3)
            break
        }
      }
      // console.log(this.JSON)
      // console.log(this.JSONlist)
      this.JSON += this.JSONlist.sort()
      // console.log(this.JSON)
      this.SendCommand(this.JSON)
    },
    SendCommand (content) {
      // console.log(content)
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
        this.JSON = "$STORE,1,"
        this.JSONlist = []
      }).catch(err => {
        this.$Message.error(err)
          this.JSON = "$STORE,1,"
          this.JSONlist = []
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
